import { render, staticRenderFns } from "./district.vue?vue&type=template&id=7da95ad6&scoped=true&"
import script from "./district.vue?vue&type=script&lang=js&"
export * from "./district.vue?vue&type=script&lang=js&"
import style0 from "./district.vue?vue&type=style&index=0&id=7da95ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da95ad6",
  null
  
)

export default component.exports